import { useMemo, useState } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useEffectOnce } from 'react-use';

import { Wizard } from '../../../components/Wizard/Wizard';
import { useStores } from '../../../stores/useStores';
import { WizardStore } from '../../../stores/wizard/WizardStore';
import { usePocWizardConfig } from '../PocWizard/usePocWizardConfig';

import styles from './PocReactionDialog.module.scss';
import { PocReactionSuccessView } from './PocReactionSuccessView';

export function pocReactionDialogFactory(skipImpressionStep?: boolean) {
  return observer(function PocReactionDialog() {
    const pocWizardConfig = usePocWizardConfig(skipImpressionStep);
    const { portalStore, pocStore } = useStores();
    const [localWizardStore] = useState(() => new WizardStore());

    useEffectOnce(() => {
      void pocStore.noticeCurrentPocSession();
    });

    const reactionWizardConfig = useMemo(() => {
      const allSteps = [...pocWizardConfig.steps, PocReactionSuccessView];

      const stepsMapping = pocWizardConfig.getStepsMapping(-1);
      const successStepIdx = allSteps.indexOf(PocReactionSuccessView);

      return {
        steps: allSteps.map((step) => {
          if ('factoryName' in step) {
            return step.factory(stepsMapping, 0, {
              onClose: () => portalStore.closePortal(),
              onSuccess: () => localWizardStore.forceStep(successStepIdx),
            });
          }

          return step;
        }),
        stepsMapping,
      };
    }, [pocWizardConfig, portalStore, localWizardStore]);

    return (
      <Wizard
        classNameWrapper={classNames(styles.pocReactionDialog, {
          [styles.allowOverflow]: localWizardStore.step === reactionWizardConfig.stepsMapping.initPoc,
        })}
        localWizardState={localWizardStore}
        steps={reactionWizardConfig.steps}
      />
    );
  });
}
